import { Hidden } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { CpgAppSelect } from '../../../cic/cic-app-dropdown';
import { AccountInfoRoutes } from '../../../pages/account-info/constants/routes';
import { ArcRoutes } from '../../../pages/arc/constants/routes';
import { AlertSites, Notification, NotificationStatus, SiteWideNotification } from '../../../pages/notification/notification-models';
import { SiteWideNotifications } from '../../../pages/notification/site-wide-notification';
import { TcsmStates } from '../../../root/tcsm-model';
import { useBasePath } from '../../hooks/useBasePath';
import { UserContext } from '../../models/app-context-model';
import { Navigation } from '../../models/navigation-model';
import { GlobalSearch } from './global-search';
import { NavBar } from './nav-bar';
import { StickyNavsHandler } from './sticky-nav';


interface TopNavProps {
	navigation: Navigation,
}

let stickNavHandler: StickyNavsHandler;
const SmallHeaderClass = 'small-header';

export const TopNavigation = (props: TopNavProps) => {

	const navRef = useRef<HTMLDivElement>(null);
	const userContext = useSelector<TcsmStates, UserContext>(a => a.appContext?.userContext);
	const notificationLink = window?.location?.pathname?.includes(ArcRoutes.ArcRoot) ?
		`${useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.Notifications}`)}?tab=unread` :
		`${useBasePath(`${AccountInfoRoutes.MyCpgRoot}${ArcRoutes.Notifications}`)}?tab=unread`;

	const notifactions = useSelector<TcsmStates, Notification[]>(state => state?.notificationState?.notifications);
	const siteSettingsLoaded = useSelector<TcsmStates, boolean>(state => state?.epiProps?.siteSettingsState?.siteSettingsLoaded);
	const siteWideAlerts = useSelector<TcsmStates, SiteWideNotification[]>(state => state?.epiProps?.siteSettingsState?.siteSettings?.siteWideAlertBlocks);
	const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
	const [newNotification, setNewNotification] = useState(false);
	const [siteNotificationClosed, setSiteNotificationClosed] = useState(false);
	useEffect(() => {
		setNewNotification(() => notifactions?.some(a => a.notification_status === NotificationStatus.INITIAL));
	}, [notifactions]);

	useEffect(() => {
		if (stickNavHandler) {
			setTimeout(() => {
				stickNavHandler.setHeightProperties();

			}, 250);
		}
	}, [mobileSearchOpen]);

	useEffect(() => {
		if (stickNavHandler) {
			setTimeout(() => {
				stickNavHandler.setHeightProperties();

			}, 250);
		}
	}, [siteNotificationClosed]);

	useEffect(() => {
		if (stickNavHandler) {
			setTimeout(() => {
				stickNavHandler.setHeightProperties();
			}, 250);
		}
	}, [siteWideAlerts]);

	useEffect(() => {
		if (stickNavHandler) {
			setTimeout(() => {
				stickNavHandler.setHeightProperties();
			}, 250);
		}
	}, [userContext]);

	useEffect(() => {
		if (!stickNavHandler && navRef.current && siteSettingsLoaded) {
			setTimeout(() => {
				stickNavHandler = new StickyNavsHandler([navRef.current]);

				// Recalculate body margin-top whenever the nav height changes
				if (typeof ResizeObserver !== 'undefined' && navRef.current) {
					const resizeObserver = new ResizeObserver(() => {
						stickNavHandler.setHeightProperties();
					});
					resizeObserver.observe(navRef.current);
				}

				let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
				window.addEventListener('scroll', () => {
					const headerHeight = stickNavHandler.activeHeight;

					const st = window.pageYOffset || document.documentElement.scrollTop;

					if (st > lastScrollTop && st > headerHeight) {
						stickNavHandler.addHeaderClass(SmallHeaderClass);

					} else {
						stickNavHandler.removeHeaderClass(SmallHeaderClass);

					}
					lastScrollTop = st <= 0 ? 0 : st;
				}, false);
			}, 1000);
		}
	}, [siteSettingsLoaded]);

	const toggleMobileSearch = () => {
		setMobileSearchOpen(previousValue => !previousValue);
	};


	const renderMobileSearch = () => {
		if (!mobileSearchOpen) return null;

		return (
			<Hidden mdUp>
				<div className='nav-search nav-search-mobile '> {/*THIS IS THE FIELD*/}
					<GlobalSearch isTcsm />
				</div>
			</Hidden>
		);

	};

	const mobileTrigger = {
		class: mobileSearchOpen ? 'nav-search-mobile-trigger-open' : 'nav-search-mobile-trigger-closed',
		iconName: mobileSearchOpen ? '#close-icon' : '#search-icon',
	};


	return (
		<header>
			<div ref={navRef} className='nav-container'>

				<nav className='nav-top'>
					<SiteWideNotifications setSiteNotificationClosed={setSiteNotificationClosed} site={AlertSites.TCSM} />
					<div className='nav-top-inner'>
						<div className='nav-logo'>
							<a href='/' target="_blank" >
								<img className='nav-logo-image' src='/Static/img/cpg_logo_tcsm.png' alt={props.navigation?.LogoAltText} />
								<img className='nav-logo-print' src='/Static/img/cpg_header_logo.svg' alt={props.navigation?.LogoAltText} />

							</a>
						</div>
						<div className='nav-utility'>
							<CpgAppSelect navigation={props.navigation} />
							<a className={`nav-notification ${newNotification ? 'new-notification' : ''}`} href={notificationLink}>
								<svg className='info-icon' aria-hidden='true' focusable='false'>
									<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#bell-icon' />
								</svg>
								<span className='visually-hidden'>Notification</span>
							</a>
							<Hidden mdUp>
								<button
									className={`nav-search-mobile-trigger ${mobileTrigger.class}`}
									onClick={toggleMobileSearch}
									type='button'>
									<svg className='info-icon' aria-hidden='true' focusable='false'>
										<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref={mobileTrigger.iconName} />
									</svg>
									<span className='visually-hidden'>Search Trigger</span></button>
							</Hidden>
							<Hidden smDown> {/*THIS IS DESKTOP*/}
								<div className='nav-search nav-search-desktop'>
									<GlobalSearch isTcsm />
								</div>
							</Hidden>
						</div>
					</div>
					{renderMobileSearch()}
				</nav>
				{
					(userContext && userContext !== UserContext.MINIMAP) &&
					<NavBar admin={userContext === UserContext.ARC} navigation={props.navigation} />
				}
			</div>
		</header>
	);
};
